export const DEVICE_LINK_SYMBOLS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
export const DEVICE_LINK_KEYPAD_SYMBOLS = ["1", "2", "3", "A", "4", "5", "6", "B", "7", "8", "9", "C", "E", "0", "F", "D"];
export const DEVICE_LINK_CODE_LENGTH = 6;
export const DEVICE_LINK_GROUP_SIZE = 3;

export function normalizeDeviceLinkCode(value) {
  return String(value || "")
    .toUpperCase()
    .replace(/[^0-9A-F]/g, "")
    .slice(0, DEVICE_LINK_CODE_LENGTH);
}

export function formatDeviceLinkCode(value) {
  const normalized = normalizeDeviceLinkCode(value);
  const groups = [];

  for (let index = 0; index < normalized.length; index += DEVICE_LINK_GROUP_SIZE) {
    groups.push(normalized.slice(index, index + DEVICE_LINK_GROUP_SIZE));
  }

  return groups.join("-");
}

export function isCompleteDeviceLinkCode(value) {
  return normalizeDeviceLinkCode(value).length === DEVICE_LINK_CODE_LENGTH;
}
